var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.description)+" ")]),_c('video',{attrs:{"id":"video","controls":"","preload":"metadata","width":"854","height":"480"}},[_c('p',[_vm._v(" ご利用のブラウザーは当サイトの動画に対応していません。申し訳ありませんが，別のブラウザーソフトをお試しください。 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }